import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';

import { CampanhaROIPipelineWidgetsComponent } from './campanha-roi-pipeline-widgets.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaROIPipelineWidgetsComponent
    ],
    exports: [
        CampanhaROIPipelineWidgetsComponent
    ]
})
export class CampanhaROIPipelineWidgetsModule { }
